document.addEventListener("visitorConsentCollected", (event) => {
  Shopify.analytics.publish("user_consent", {"consent": event.detail});
});

window.addEventListener('beforeunload', function(e) {
  Shopify.analytics.publish("data_layer_event", {dataLayer:{event: "user_engagement"}});
});

(function(dl_name) {
  function analytics_handler (dl_obj) {
    var curr_obj = dl_obj[0];
    var send_obj = {};
    
    if (curr_obj["event"] && allowed_events) {

      for (var allowed_event in allowed_events) {
        var event_index = curr_obj["event"].indexOf(allowed_events);

        if (allowed_event === curr_obj["event"]) {

          send_obj.event = allowed_events[allowed_event].event;
          send_obj.event_params = {};
          
          for (var obj_index in allowed_events[allowed_event].obj) {
            if (typeof curr_obj[allowed_events[allowed_event].obj[obj_index]] !== "undefined") {
              send_obj.event_params[allowed_events[allowed_event].obj[obj_index]] = curr_obj[allowed_events[allowed_event].obj[obj_index]];
            }
          }
  
          send_obj.event_params.u_state = page_data.state;

          Shopify.analytics.publish("data_layer_event", {dataLayer: send_obj});
        }
      }
    }
  };
  
  window[dl_name] = window[dl_name] || [];
  const dl_push = window[dl_name].push;
  
  window[dl_name].push = function(...args) {
    dl_push.apply(this, args);
    
    try{ analytics_handler(args); }catch(e) {  }
  };

  const page_data = {
    "state": "logged_out"
  };

  const allowed_events = {
    "click_navigation": {
      "event": "navigation_click",
      "obj":["breadcrumb"]
    },
    "wishlist_send": { "event": "send_wishlist" }
  };
})("dataLayer");